import { Card, Col, Row, Tabs } from 'antd'
import EmailForm from 'components/Main/Emails/EmailForm'
import React from 'react'
import CustomBreadCrumb from '../../../../components/Common/CustomBreadCrumb'
import style from '../../../../components/Sales/style.css'
import CodeIcon from '../../../../elements/CodeIcon'
import CustomSpin from '../../../../elements/CustomSpin'
import Status from '../../../../elements/Status'
import { strVal } from '../../../../modules/Utils'
import ReactHtmlParser from 'react-html-parser'

AddEmail.propTypes = {}

function AddEmail(props) {
  const { fetching, email } = props

  return (
    <CustomSpin spinning={fetching}>
      <Card>
        <Row className={style.pageHeader}>
          <CustomBreadCrumb
            items={[
              {
                text: 'Emails',
                link: '/#/email',
              },
              { text: email.subject },
            ]}
          />
          <Col span={17}>
            <h3 style={{ marginTop: '10px' }}>
              <CodeIcon code={strVal(email, '_id')} title={'Email ID'} />
              <Status value={strVal(email, 'detail.notificationType')} />
            </h3>
          </Col>
        </Row>
      </Card>
      <Card style={{ marginTop: '20px' }}>
        <Tabs defaultActiveKey="form">
          <Tabs.TabPane tab="Details" key="details">
            <EmailForm {...props} />
          </Tabs.TabPane>
          <Tabs.TabPane tab="Email Preview" key="preview">
            <div className="px-10 py-4">
            {ReactHtmlParser(email.html || '')}
            </div>
          </Tabs.TabPane>
        </Tabs>
      </Card>
    </CustomSpin>
  )
}

export default AddEmail
